<template>
<div class="chapter">
<div class="inner_page">
<div class="chap" id="ded">
<p class="ded">To all the troops who died while generals dithered</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// spblinesoffire0005.vue?16e20a46